import React, { useState,useRef,useEffect } from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ListGroup,
  ListGroupItem,
  Nav, NavItem, NavLink, TabContent, TabPane, FormGroup, Label, Input , Row,
  Col,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { Formik, Form,Field,ErrorMessage } from "formik";
import { getAvailableBalance,getRangeList,getPayInOutList,showMessage,addFund,withdrawFund} from "store/reducers/common.slice";
import InfiniteScroll from "react-infinite-scroll-component";
import bankicon from "assets/img/icons/bank_card_icon.png";
import classnames from "classnames";
const WalletDropdown = () => {
  const dispatch = useDispatch();   
  const { availableBalance,amountRangeList,whatappRecords,isAddFund,addFundLoading,iswithdrawFund,withdrawFundLoading,payInList,payOutList,totalPayInRecord,totalPayOutRecord,payInOutListLoading} = useSelector(
    ({ common }) => common
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
  const [isViewStatement, setIsViewStatement] = useState(false);
  const [selectedRange, setSelectedRange] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [copySuccess, setCopySuccess] = useState("");
  const [fundData, setFundData] = useState([]);
  const [withdrawData, setWithdrawData] = useState([]);
  const formRef = useRef(null);
  useEffect(() => {
    if (isAddFund) {
      if (formRef && formRef.current) {
          formRef.current.resetForm();
      }
      setIsModalOpen(false);
      setActiveTab("1") 
      setIsPaymentModalOpen(false);  
    }
  }, [isAddFund]);
  useEffect(() => {
    if (iswithdrawFund) {
      if (formRef && formRef.current) {
          formRef.current.resetForm();
      }
      setIsModalOpen(false);
      setActiveTab("1") 
      setIsWithdrawModalOpen(false);  
    }
  }, [iswithdrawFund]);
  const validationAddFundSchema = Yup.object().shape({
    transactionId: Yup.string().required("Transaction ID is required"),
    amount: Yup.number().required("Amount is required").positive("Amount must be positive").test(
        "min-max-range",
        `Amount must be between ${selectedRange.startAmountRange} and ${selectedRange.endAmountRange}`,
        (value) => value >= selectedRange.startAmountRange && value <= selectedRange.endAmountRange
      ),
    remark: Yup.string().optional(),
    transactionFile: Yup.mixed().required("Payment receipt is required"),
  });
  const validationUPISchema = Yup.object().shape({
      upiId: Yup.string()
        .matches(/^[\w.-]+@[\w]+$/, "Enter a valid UPI ID")
        .required("UPI ID is required"),
      amount: Yup.number()
        .positive("Amount must be positive")
        .required("Amount is required"),
  });
  const validationWithdrawSchema = Yup.object().shape({
      beneficiaryName: Yup.string().required("Beneficiary Name is required"),
      bankName: Yup.string().required("Bank Name is required"),
      ifscCode: Yup.string()
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC Code")
        .required("IFSC Code is required"),
      accountNumber: Yup.string().required("Account Number is required"),
      reEnterAccountNumber: Yup.string()
        .oneOf([Yup.ref("accountNumber")], "Account numbers must match")
        .required("Please re-enter Account Number"),
      amount: Yup.number()
        .positive("Amount must be positive")
        .required("Amount is required"),
  });
  const initialAddFundValues = {
    transactionId: "",
    amount: "",
    remark: "",
    transactionFile: null,
  };
  const initialWithdrawValues = {
    amount: "",
    beneficiaryName: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    reEnterAccountNumber: "",
    amount: "",
  };
  const fetchMoreDataInTable = (type) => {
    return () => {
      if (payInOutListLoading) return; 
      let page = type === "pay-in" ? payInList.length / 10 + 1 : payOutList.length / 10 + 1;
      dispatch(getPayInOutList({ page, payOut: type }));
      };
  };
  const toggleModal = () => {
    if (!isModalOpen) {
      setSelectedRange("");
      dispatch(getRangeList()); 
    }
    setIsModalOpen(!isModalOpen);
  };
  const togglePaymentModal = () => {
    setIsPaymentModalOpen(!isPaymentModalOpen);
  };
  const toggleWithdrawModal = () => {
    setIsWithdrawModalOpen(!isWithdrawModalOpen);
  };
 const toggleViewStatement = () => {
    setActiveTab("1") 
    setIsViewStatement(!isViewStatement);
    dispatch(getPayInOutList({page:1,payOut:'pay-in'})); 
  };

  const handleRangeSelect = (item) => {
    setSelectedRange(item);
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    dispatch(showMessage({ message: "Content Copied to Clipboard" }));
  };
  const handleSubmit = () => {
  if (selectedRange?.whatsAppNumber) {
    const whatsappURL = `https://wa.me/${selectedRange.whatsAppNumber}?text=Hello,%20I%20want%20to%20add%20points.`;
    window.open(whatsappURL, "_blank"); // Open in new tab
  } else {
    setIsModalOpen(false);
    setActiveTab("1") 
    setIsPaymentModalOpen(true);  
  }
};
return (
    <>
    <UncontrolledDropdown nav>
      <DropdownToggle nav onClick={() => {dispatch(getAvailableBalance());}} style={{paddingTop: "6px", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", }} >
      <span className="material-symbols-outlined" style={{ fontSize: "28px" }}> account_balance_wallet </span>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem header> Available Balance: <div style={{ fontWeight: "bold", fontSize: "16px",color: availableBalance?.crDr=="Cr" ? "green" : "red"}}>{availableBalance?.balance} {availableBalance?.crDr}</div> </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={toggleModal} style={{ cursor: "pointer" }}> ADD POINT </DropdownItem>
        <DropdownItem onClick={toggleWithdrawModal} style={{ cursor: "pointer" }}> WITHDRAW </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={toggleViewStatement} style={{ fontWeight: "bold", color: "#007bff", cursor: "pointer" }} >
          View Statement
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
    <Modal isOpen={isViewStatement} toggle={toggleViewStatement} centered size="lg">
        <ModalHeader toggle={toggleViewStatement}>Statement</ModalHeader>
        <div className="modal-body">
          <Nav tabs className="mb-3 d-flex justify-content-between">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={`py-2 fw-bold ${activeTab === "1" ? "active" : ""}`}
               onClick={() => {
                setActiveTab("1");
                dispatch(getPayInOutList({page:1,payOut:'pay-in'}));
              }}
              style={{ fontSize: "18px", cursor: "pointer" }}
            >
              Add Fund
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={`py-2 fw-bold ${activeTab === "2" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("2");
                dispatch(getPayInOutList({page:1,payOut:'pay-Out'}));
              }}
              style={{ fontSize: "18px", cursor: "pointer" }}
            >
              Withdraw Fund
            </NavLink>
          </NavItem>
        </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
             <div id="custom_table_observer_1" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <InfiniteScroll
                dataLength={payInList.length}
                next={fetchMoreDataInTable("pay-in")}
                hasMore={payInList.length < totalPayInRecord}
                scrollableTarget="custom_table_observer_1"
              >
                <table className="table-flush table table-medium card_bold">
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Remark</th>
                      <th>CR/DR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payInList.map((item, index) => (
                      <tr key={index}>
                        <td>{index+1}</td>
                        <td>{item.statusName}</td>
                        <td>{item.amount}</td>
                        <td>{item.addTime}</td>
                        <td>{item.remark}</td>
                        <td>Credit</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </InfiniteScroll>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div id="custom_table_observer_2" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <InfiniteScroll
                dataLength={payOutList.length}
                next={fetchMoreDataInTable('pay-Out')}
                hasMore={payOutList.length < totalPayOutRecord}
                scrollableTarget="custom_table_observer_2"
              >
                <table className="table-flush table table-medium card_bold">
                  <thead  className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Remark</th>
                      <th>CR/DR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payOutList.map((item, index) => (
                        <tr key={index}>
                        <td>{index+1}</td>
                        <td>{item.statusName}</td>
                        <td>{item.amount}</td>
                        <td>{item.addTime}</td>
                        <td>{item.remark}</td>
                        <td>Debit</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </InfiniteScroll>
              </div>
            </TabPane>
          </TabContent>
        </div>
    </Modal>
    <Modal isOpen={isModalOpen} toggle={toggleModal} >
        <ModalHeader toggle={toggleModal}>Select a range</ModalHeader>
        <ModalBody>
          <ListGroup>
            {amountRangeList.map((item, index) => (
              <ListGroupItem key={item.id} onClick={() => handleRangeSelect(item)} style={{display: "flex", alignItems: "center", cursor: "pointer", border: "none", padding: "10px 15px", position: "relative", }} >
                <img src={bankicon} alt="icon" style={{ width: "30px", height: "30px", marginRight: "10px" }} />
                <div style={{ flex: 1 }}>{item.startAmountRange} - {item.endAmountRange}</div>
                {selectedRange?.id === item.id && (<span style={{ fontWeight: "bold", color: "green", fontSize: "20px" }}>✔</span> )}
              </ListGroupItem>
            ))}
            {whatappRecords.length > 0 && whatappRecords.map((whatsApp) => (
              <ListGroupItem key={whatsApp.id} onClick={() => handleRangeSelect(whatsApp)} style={{display: "flex", alignItems: "center", cursor: "pointer", border: "none", padding: "10px 15px", position: "relative", }} >
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "30px", height: "30px", marginRight: "10px" }} />
                <div style={{ flex: 1 }}>Add Point via WhatsApp</div>
                {selectedRange?.id === whatsApp.id && (<span style={{ fontWeight: "bold", color: "green", fontSize: "20px" }}>✔</span> )}
              </ListGroupItem>
            ))}
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-icon btn-3 mt-0" color="default" disabled={!selectedRange} onClick={handleSubmit}>
            Submit
          </Button>
        </ModalFooter>
    </Modal>
    <Modal isOpen={isPaymentModalOpen} toggle={togglePaymentModal} centered size="lg">
     {addFundLoading &&
        <div className="spinner-box">
          <Spinner className="ml-2" color="primary" />
        </div>
      }
      <ModalHeader toggle={togglePaymentModal}>Make Payment</ModalHeader>
      <ModalBody>
        {/* Tabs for UPI & Bank Account */}
        <Nav tabs className="mb-3 d-flex justify-content-between">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={`py-2 fw-bold ${activeTab === "1" ? "active" : ""}`}
               onClick={() => {
                setActiveTab("1");
                formRef.current.resetForm();
              }}
              style={{ fontSize: "18px", cursor: "pointer" }}
            >
              UPI
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={`py-2 fw-bold ${activeTab === "2" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("2");
                formRef.current.resetForm();
              }}
              style={{ fontSize: "18px", cursor: "pointer" }}
            >
              Bank Account
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} className="mb-3">
          {/* UPI Details */}
          <TabPane tabId="1">
            <Row>
              <Col md={6}>
                <p className="mb-1">
                  <strong>UPI ID:</strong> {selectedRange.bankUPI}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankUPI)}>📋</Button>
                  {copySuccess === selectedRange.bankUPI && <span className="text-success"> Copied!</span>}
                </p>
                <p className="mb-1">
                  <strong>Range:</strong> {selectedRange.startAmountRange} - {selectedRange.endAmountRange}
                </p>
              </Col>
              <Col md={6} className="text-center">
                <img src={selectedRange.bankUPIImage} alt="UPI QR" className="rounded shadow mt-2" style={{ width: "150px" }} />
              </Col>
            </Row>
          </TabPane>

          {/* Bank Details */}
          <TabPane tabId="2">
            <Row>
              <Col md={6}>
                <p className="mb-1"><strong>Bank Name:</strong> {selectedRange.bankName}</p>
                <p className="mb-1">
                  <strong>Account No:</strong> {selectedRange.bankAccountNumber}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankAccountNumber)}>📋</Button>
                  {copySuccess === selectedRange.bankAccountNumber && <span className="text-success"> Copied!</span>}
                </p>
                <p className="mb-1">
                  <strong>Account Name:</strong> {selectedRange.bankHolderName}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankHolderName)}>📋</Button>
                  {copySuccess === selectedRange.bankHolderName && <span className="text-success"> Copied!</span>}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-1">
                  <strong>IFSC Code:</strong> {selectedRange.bankIFSC}
                  <Button size="sm" color="link" onClick={() => handleCopy(selectedRange.bankIFSC)}>📋</Button>
                  {copySuccess === selectedRange.bankIFSC && <span className="text-success"> Copied!</span>}
                </p>
                <p className="mb-1">
                  <strong>Range:</strong> {selectedRange.startAmountRange} - {selectedRange.endAmountRange}
                </p>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
        <Formik enableReinitialize={true} validationSchema={validationAddFundSchema} innerRef={formRef} initialValues={initialAddFundValues}  onSubmit={async (valuesData) => {
                dispatch(addFund(valuesData));
              }}> 
          {({ value,handleChange,handleBlur, setFieldValue, errors, touched }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="text"
                      name="transactionId"
                      placeholder="Transaction ID"
                      className="py-2"
                      invalid={touched.transactionId && !!errors.transactionId}
                    />
                   <span className="text-error"> <ErrorMessage name="transactionId" /> </span>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="number"
                      name="amount"
                      placeholder="Amount"
                      className="py-2"
                      invalid={touched.amount && !!errors.amount}
                    />
                    <span className="text-error"> <ErrorMessage name="amount" /> </span>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Field
                      as={Input}
                      type="text"
                      name="remark"
                      placeholder="Remark"
                      className="py-2"
                      invalid={touched.remark && !!errors.remark}
                    />
                     <span className="text-error"> <ErrorMessage name="remark" /> </span>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Input
                      type="file"
                      name="transactionFile"
                      accept="image/*"
                      className="py-2"
                       onChange={(event) => {
                        const file = event.currentTarget.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setFieldValue("transactionFile", reader.result.split(",")[1]); // Extract Base64
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                    <span className="text-error"> <ErrorMessage name="transactionFile" /> </span>
                  </FormGroup>
                </Col>
              </Row>
              <ModalFooter>
                <Button type="submit" color="default" className="btn-icon btn-3 mt-0 w-100 py-2">Submit</Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
    <Modal isOpen={isWithdrawModalOpen} toggle={toggleWithdrawModal} centered size="lg">
      {withdrawFundLoading &&
        <div className="spinner-box">
          <Spinner className="ml-2" color="primary" />
        </div>
      }
      <ModalHeader toggle={toggleWithdrawModal}>Withdraw</ModalHeader>
      <ModalBody>
        <Nav tabs className="mb-3 d-flex justify-content-between">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames("py-2 fw-bold", { active: activeTab === "1" })}
              onClick={() => {
                setActiveTab("1");
                formRef.current.resetForm({ values: initialWithdrawValues });
              }}
              style={{ cursor: "pointer", fontWeight: "bold" }}
            >
              UPI
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames("py-2 fw-bold", { active: activeTab === "2" })}
              onClick={() => {
                setActiveTab("2");
                formRef.current.resetForm({values: {upiId: "", amount: "" }});
              }}
              style={{ cursor: "pointer", fontWeight: "bold" }}
            >
              Bank Account
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Formik
              initialValues={{ upiId: "", amount: "" }}
              validationSchema={validationUPISchema}
              innerRef={formRef}
              onSubmit={(values) => dispatch(withdrawFund(values))}
            >
              {({ errors, touched }) => (
                <Form>
                  <FormGroup>
                    <Field as={Input} type="text" name="upiId" placeholder="Enter UPI ID" />
                    <span className="text-error"><ErrorMessage name="upiId" /></span>
                  </FormGroup>
                  <FormGroup>
                    <Field as={Input} type="number" name="amount" placeholder="Enter Amount" />
                    <span className="text-error"><ErrorMessage name="amount" /></span>
                  </FormGroup>
                  <ModalFooter>
                    <Button type="submit" color="default" className="w-100 py-2 btn-icon btn-3 mt-0">Submit</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </TabPane>
          <TabPane tabId="2">
            <Formik
              initialValues={initialWithdrawValues}
              validationSchema={validationWithdrawSchema}
              innerRef={formRef}
              onSubmit={(values) => dispatch(withdrawFund(values))}
            >
              {({ errors, touched }) => (
                <Form>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="beneficiaryName" placeholder="Enter Beneficiary Name" />
                        <span className="text-error"><ErrorMessage name="beneficiaryName" /></span>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="bankName" placeholder="Enter Bank Name" />
                        <span className="text-error"><ErrorMessage name="bankName" /></span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Field as={Input} type="text" name="ifscCode" placeholder="Enter IFSC Code" />
                        <span className="text-error"><ErrorMessage name="ifscCode" /></span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="accountNumber" placeholder="Enter Account Number" />
                        <span className="text-error"><ErrorMessage name="accountNumber" /></span>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Field as={Input} type="text" name="reEnterAccountNumber" placeholder="Re-Enter Account Number" />
                        <span className="text-error"><ErrorMessage name="reEnterAccountNumber" /></span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Field as={Input} type="number" name="amount" placeholder="Enter Amount" />
                        <span className="text-error"><ErrorMessage name="amount" /></span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <ModalFooter>
                    <Button type="submit" color="default" className="w-100 py-2 btn-icon btn-3 mt-0">Submit</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
    </>
  );
};
export default WalletDropdown;
